import Component from 'navigation/component/Component';
import Form from 'components/form/Form';
import AddToWishlist from 'components/add-to-wishlist/AddToWishlist';
import { bindMethod } from 'helpers/bind';
import { completeAddToCart, sendProductForm, startAddToCartLoading } from 'helpers/addToCartButton';
class BundleProductRow extends Component {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            form: ['.bundle-product-row__form', Form],
            addToWishlist: ['.add-to-wishlist', AddToWishlist]
        };
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        this.refs.addToCart?.forEach((el) => el[method]('click', this.onAddToCart));
        this.refs.toggleSizeSelector?.forEach((el) => el[method]('click', this.onToggleSizeSelector));
    }
    onToggleSizeSelector = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openSizePanel();
    };
    // the page builds the panel url: it knows the current product of every item
    openSizePanel() {
        this.emit('size:open', Number(this.el.dataset.index));
    }
    onAddToCart = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.modules.form.setSubmitted(false);
        const valid = await this.modules.form.quickValid();
        if (!valid) {
            this.openSizePanel();
            return;
        }
        const btn = e.currentTarget;
        await startAddToCartLoading([btn]);
        sendProductForm({
            form: this.modules.form,
            submitter: btn,
            callback: ({ data, xhr }) => {
                completeAddToCart([btn], data.error !== null);
                this.onAddToCartDone({ data, xhr });
            }
        });
    };
    onAddToCartDone = ({ data, xhr }) => {
        if (!data.error)
            this.emit('add-to-cart', { xhr });
    };
    syncSize = (e) => {
        this.refs.sizeInput?.forEach((input) => {
            if (e[input.name] === undefined)
                return;
            input.value = e[input.name];
            input.dispatchEvent(new Event('change'));
        });
        this.refs.sizeLabel?.forEach((label) => {
            if (e[label.dataset.inputName] === undefined)
                return;
            label.textContent = e.label;
        });
    };
}
export default BundleProductRow;
